import { Culqi3DSSettingsDto, Culqi3DSOptionsDto } from '../../dto'

export const DEFAULT_SETTINGS_CULQI_3DS: Culqi3DSSettingsDto = {
	charge: {
		totalAmount: 0,
		returnUrl: ''
	},
	card: {
		email: ''
	}
};

export const DEFAULT_OPTIONS_CULQI_3DS: Culqi3DSOptionsDto = {
	showModal: true,
	showLoading: true,
	showIcon: true,
	style: {
		btnColor: '#193b48',
		btnTextColor: '#FFFFFF'
	}
};
